// extracted by mini-css-extract-plugin
export var author = "author-module--author--lfTnN";